import { render, staticRenderFns } from "./SceneSelector.vue?vue&type=template&id=5170d554&scoped=true"
import script from "./SceneSelector.vue?vue&type=script&lang=js"
export * from "./SceneSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5170d554",
  null
  
)

export default component.exports